<template>
  <div class="results-list__wrapper result-skeleton" aria-hidden="true">
    <div class="results-list__wrapper--thumbnails">
      <div class="result-skeleton__block result-skeleton__image"></div>
    </div>

    <div class="results-list__wrapper--content result-skeleton__content">
      <div class="result-skeleton__block result-skeleton__line--tag"></div>
      <div class="result-skeleton__block result-skeleton__line--title"></div>
      <div class="result-skeleton__amenities">
        <div
          v-for="n in 9"
          :key="n"
          class="result-skeleton__block result-skeleton__icon"
        ></div>
      </div>
      <div class="result-skeleton__block result-skeleton__line--location"></div>
      <div class="result-skeleton__reviews">
        <div class="result-skeleton__block result-skeleton__score"></div>
        <div
          class="result-skeleton__block result-skeleton__line--reviews"
        ></div>
      </div>
    </div>

    <div
      class="results-list__wrapper--price is-flex is-flex-direction-column is-justify-content-center is-align-items-center result-skeleton__price"
    >
      <div class="result-skeleton__block result-skeleton__line--price"></div>
      <div class="result-skeleton__price-icons">
        <div class="result-skeleton__block result-skeleton__icon--lg"></div>
        <div class="result-skeleton__block result-skeleton__icon--lg"></div>
      </div>
      <div class="result-skeleton__block result-skeleton__button"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultItemSkeleton"
};
</script>

<style scoped lang="scss">
.result-skeleton {
  &__block {
    background: linear-gradient(90deg, #ececec 25%, #f6f6f6 50%, #ececec 75%);
    background-size: 200% 100%;
    border-radius: 4px;
    animation: result-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  &__image {
    min-height: 154px;
    border-radius: 6px;
  }

  &__content {
    gap: 0.6rem;
    justify-content: flex-start;
  }

  &__line--tag {
    width: 160px;
    height: 18px;
  }

  &__line--title {
    width: 60%;
    max-width: 260px;
    height: 22px;
  }

  &__amenities {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    max-width: 290px;
  }

  &__icon {
    width: 18px;
    height: 18px;
  }

  &__line--location {
    width: 220px;
    max-width: 80%;
    height: 14px;
  }

  &__reviews {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__score {
    width: 22px;
    height: 22px;
  }

  &__line--reviews {
    width: 180px;
    max-width: 70%;
    height: 14px;
  }

  &__price {
    gap: 0.75rem;
  }

  &__line--price {
    width: 120px;
    height: 22px;
  }

  &__price-icons {
    display: flex;
    gap: 12px;
  }

  &__icon--lg {
    width: 26px;
    height: 26px;
    border-radius: 50%;
  }

  &__button {
    width: 132px;
    height: 42px;
    border-radius: 21px;
  }

  @media screen and (max-width: 800px) {
    &__content,
    &__price {
      padding-top: 1rem;
    }
  }
}

@keyframes result-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .result-skeleton__block {
    animation: none;
  }
}
</style>
